import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const ListFaqCategoryPage = loadable(() => import('./ListFaqCategoryPage'), {
    fallback: <Loader/>,
});
const AddFaqCategoryPage = loadable(() => import('./AddFaqCategoryPage'), {
    fallback: <Loader/>,
});
const EditFaqCategoryPage = loadable(() => import('./EditFaqCategoryPage'), {
    fallback: <Loader/>,
});
const FaqCategoryRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route key={"faq_category_list"} index exact path="/list" element={<ListFaqCategoryPage t={t} alert={alert} />} />
      <Route key={"faq_category_add"} exact path="/add" element={<AddFaqCategoryPage t={t} alert={alert} />} />
      <Route key={"faq_category_edit"} exact path="/edit/:id" element={<EditFaqCategoryPage t={t} alert={alert} />} />
      <Route key={"faq_category_no_page_found"} path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
FaqCategoryRoute.propTypes = {
  t: PropTypes.func
};
export default FaqCategoryRoute;
